import { forwardRef } from 'react';
import type { TextareaHTMLAttributes } from 'react';
import { cn } from '@/lib/cn';

export const Textarea = forwardRef<
  HTMLTextAreaElement,
  TextareaHTMLAttributes<HTMLTextAreaElement>
>(({ className, rows = 4, ...props }, ref) => (
  <textarea
    ref={ref}
    rows={rows}
    className={cn(
      'w-full rounded-inset border-2 border-hairline-strong bg-surface px-3.5 py-2.5 text-sm text-ink',
      'placeholder:text-ink-faint',
      'transition-[border-color] duration-150',
      'focus-visible:border-ink focus-visible:outline-none',
      'disabled:cursor-not-allowed disabled:opacity-50',
      'aria-[invalid=true]:border-critical',
      className,
    )}
    {...props}
  />
));
Textarea.displayName = 'Textarea';
